import React from "react";
import {QRCodeSVG} from "qrcode.react";

/**
 * The one-time authenticator set-up for an agent: a QR code to scan into Google/Microsoft Authenticator, and the
 * secret for typing in by hand. The server never shows it again; a new set-up replaces it.
 */
const AuthenticatorSetup = ({name, setup, onDone}) => (
    <div className="brk-notice brk-notice--info" role="dialog" aria-label={`Authenticator set-up for ${name}`}
         style={{display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center", marginBottom: 16}}>
        <div style={{background: "#fff", padding: 12, borderRadius: 10, lineHeight: 0}}>
            <QRCodeSVG value={setup.otpauthUri} size={176} level="M" title={`Authenticator QR code for ${name}`}/>
        </div>
        <div style={{flex: "1 1 260px", minWidth: 0}}>
            <p className="brk-strong" style={{margin: "0 0 6px"}}>Authenticator for {name}</p>
            <ol style={{margin: "0 0 10px", paddingLeft: 18}}>
                <li>On {name}'s phone, open <b>Google Authenticator</b> or <b>Microsoft Authenticator</b> and tap <b>+</b> → <b>Scan a QR code</b>.</li>
                <li>Scan this code. An entry "OneGlobalMarketplace" appears with a 6-digit code.</li>
                <li>In the OGM Agent app: enter mobile <b>{setup.account}</b>, tap <b>I use an authenticator app</b>, and type the current code.</li>
            </ol>
            <p className="brk-hint" style={{margin: "0 0 10px", wordBreak: "break-all"}}>
                Can't scan? Enter this key instead: <code>{setup.secret.match(/.{1,4}/g).join(" ")}</code>
            </p>
            <p className="brk-hint" style={{margin: "0 0 10px"}}>This code is shown only now. Setting up again makes a new one and the old entry stops working.</p>
            <button type="button" className="brk-btn brk-btn--primary brk-btn--sm" onClick={onDone}>Done</button>
        </div>
    </div>
);

export default AuthenticatorSetup;
